<template>
  <div class="box">
    <div class="nav">
      <div class="city">
        <i class="icon-size el-icon-location"></i>
        <scity optionalTabs="pc" @input="input" :data="data" ref="areaTips" :clearable="false" :isHome="true" placeholder="请选择地址"></scity>
      </div>
      <div class="right-info">
        <ul class="detail" v-if="topInfo" v-html="topInfo.header.topContent"></ul>
        <span>
            <!-- <span class="username-p">
            <span>请登录</span>
          </span> -->
            <span class="username-p">
              <span>
                <span class="username" v-if="topInfo"> HI, {{topInfo.userVo.name}} 欢迎来到员工商城</span>
                <span class="signout">
                  <a href="/userauth/userLogout/logout?clientType=mall">退出</a>
                </span>
              </span>
            </span>
        </span>
        <ul>
        <li>
          <router-link to="/mymall">
            我的工作台
          </router-link>
        </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import Scity from '@/components/vue-area/scity.vue'
import storage from '@/plugins/storage.js'
import homeApi from '@/api/home'
import response from '@/utils/response'
export default {
  name: 'M-Header',
  created () {
    console.log(this.purPageinfo)
    if (storage.getItem('userInfo')) {
      this.userInfo = JSON.parse(storage.getItem('userInfo'))
    }
  },
  props: {
    purPageinfo: {
      type: Object
    }
  },
  data () {
    return {
      data: {
        province: {
          name: '',
          code: ''
        },
        city: {
          name: '',
          code: ''
        }
      },
      topInfo: '',
      userInfo: {}, // 用户信息
      shoppingCart: [] // 购物车
    }
  },
  computed: {},
  components: {
    Scity
  },
  methods: {
    input (value) {
      console.log(value)
      this.setSiteBase(value)
    },
    goToPay () {
      // 跳转购物车
      let url = this.$router.resolve({
        path: '/cart'
      })
      window.open(url.href, '_blank')
    },
    myInfo () {
      // 跳转会员中心
      let url = this.$router.resolve({
        path: '/home'
      })
      window.open(url.href, '_blank')
    },
    signOutFun () {
      // 退出登录
      this.$router.push('/login')
    },
    goUserCenter (path) {
      // 跳转我的订单，我的足迹、收藏等
    },
    // 获取首页基本信息查询
    async setSiteBase (value) {
      const getApi = homeApi.setSite
      let parms = {
        provinceCode: value.province.code,
        cityCode: value.city.code
      }
      const res = await response(this.$http(getApi.type, getApi.url, parms))
      console.log(res)
    }
  },
  watch: {
    purPageinfo (old) {
      console.log(old)
      this.topInfo = old
      this.data = {
        province: {
          name: old.thisSite.provinceName,
          code: old.thisSite.provinceCode
        },
        city: {
          name: old.thisSite.cityName,
          code: old.thisSite.cityCode
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
.box {
  width: 100%;
  height: 30px;
  line-height: 30px;
  background: #f6f6f6;
}
.nav {
  margin: 0 auto;
  width: 1200px;
  display: flex;
  height: 30px;
  flex-direction: row;
  background: #f6f6f6;
  justify-content: space-between;
  .city {
    .icon-size {
      font-size: 16px;
      color: rgb(214, 4, 19);
    }
    width: 372px;
    display: flex;
    align-items: center;
    color: #999;
    cursor: pointer;
    z-index: 99999;
    span {
      margin-left: 6px;
    }
    >>> .area-content {
      left: -16px;
    }
    >>> .mod-Scity {
      .area-input {
        border: none !important;
      }
    }
  }
  .right-info {
    display: flex;
  }
}
.nav ul {
  list-style: none;
  height: 30px;
  line-height: 30px;
}
.nav li {
  float: left;
  line-height: 30px;
  margin-right: 10px;
  color: #999;
}
.nav a,
.nav-item {
  text-decoration: none;
  padding-left: 14px;
  border-left: 1px solid #ccc;
  color: #999;
  cursor: pointer;
}
.location a {
  border-left: none;
}
.nav a:hover {
  color: $theme_color;
}

.icon {
  color: gray;
  vertical-align: middle;
}

.first a:first-child {
  padding-left: 3px;
  border-left: none;
}
.city {
  padding: 15px 15px 15px 0px;
}
.city-item {
  font-weight: bold;
  cursor: pointer;
  padding: 5px;
}
.city-item:hover {
  color: $theme_color;
}
.person-icon {
  color: $theme_color;
  background-color: #f0cdb2;
}

.shopping-cart-list {
  padding: 10px 15px;
  box-sizing: border-box;
  max-height: 300px;
  overflow: scroll;
}
.shopping-cart-box {
  margin: 8px 0px;
  margin-top: 15px;
  padding-bottom: 15px;
  height: 40px;
  display: flex;
  align-items: center;
}
.shopping-cart-box:first-child {
  margin-top: 8px;
}
.shopping-cart-img {
  margin-right: 15px;
  width: 40px;
  height: 40px;
}
.shopping-cart-img img {
  width: 100%;
}
.shopping-cart-info {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-content: space-between;
  width: 200px;
  overflow: hidden;
  font-size: 12px;
  line-height: 20px;
}

.go-to-buy {
  display: flex;
  justify-content: flex-end;
}
.shopping-cart-null {
  padding: 15px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.cart-null-icon {
  font-size: 38px;
  margin-bottom: 15px;
}
.shopping-cart-null span {
  font-size: 12px;
  line-height: 16px;
}
.username-p {
  position: relative;
  span {
    cursor: pointer;
    > span {
      margin-left: 50px;
    }
    .signout {
       margin-left: 20px;
    }
  }
  .drop-items {
    position: absolute;
    display: none;
    top: 45px;
    left: 0;
    right: 0;
    margin: 0 auto;
    padding: 5px 10px;
    z-index: 20;
    background-color: #fff;
    width: 80px;
    border: 1px solid #eee;
    box-shadow: 2px 2px 7px #999;

    li {
      color: rgb(107, 106, 106);
      width: 100%;
      border-bottom: 1px solid rgb(207, 206, 206);
      font-weight: normal;
      text-align: center;
      &:last-child {
        border: none;
      }
      &:hover {
        cursor: pointer;
        color: $theme_color;
      }
    }

    &::before {
      position: absolute;
      top: -20px;
      left: 30px;
      content: '';
      width: 0;
      height: 0;
      border: 10px solid #999;
      border-color: transparent transparent #fff transparent;
    }

    &::after {
      content: '';
      position: absolute;
      width: 80px;
      height: 20px;
      top: -20px;
      left: 0;
    }
  }
  &:hover {
    .drop-items {
      display: block;
    }
  }
}

.my-page {
  padding: 3px 5px;
  width: 180px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.my-page a {
  margin: 0px;
  padding: 0px;
  border: none;
}
.my-info {
  padding: 5px;
  width: 50%;
  height: 100%;
  text-align: center;
  cursor: pointer;
}
.my-info:hover {
  box-shadow: 0px 0px 5px #ccc;
}
.my-info i {
  font-size: 28px;
}
.my-info p {
  font-size: 12px;
}
.sign-out {
  padding: 5px;
  width: 50%;
  height: 100%;
  text-align: center;
  cursor: pointer;
}
.sign-out:hover {
  box-shadow: 0px 0px 5px $border_color;
}
.sign-out i {
  font-size: 28px;
}
.sign-out p {
  font-size: 12px;
}
.goods-title:hover {
  color: $theme_color;
}
.cart-badge {
  position: absolute;
  right: -8px;
  font-style: normal;
  background-color: $theme_color;
  color: #fff;
  font-size: 12px;
  width: 17px;
  height: 17px;
  border-radius: 10px;
  line-height: 17px;
  text-align: center;
  z-index: 3;
  top: 3px;
}
</style>



// WEBPACK FOOTER //
// src/components/header/Header.vue